export const fullTreatmentTemplateAdapter = (app) => ({
    ...app,
    diagnoses: minimizeDiagnoses(app.diagnoses),
})

function minimizeDiagnoses(diagnoses) {
    return diagnoses ? diagnoses.map(({id}) => id) : []
}
